<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="sp"> </p>
<p class="DL"><span epub:type="pagebreak" id="pg_1" title="1"><span class="ePub-I">Florence, Italy</span></span></p>
<p class="DL"><span class="ePub-I">Late November 1478</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part.vue?f4ae85e2